/*
 * Pure helpers for the CMS user name/photo fields (E19/E20) and the 409
 * HAS_ACTIVE_STUDENTS refusal (G4).
 */

export const HAS_ACTIVE_STUDENTS_CODE = 'HAS_ACTIVE_STUDENTS';

// Mirrors goserver db.AdvisorsTabLink.
export const advisors_tab_link = (uuid: string): string =>
  `/sales-task-list?tab=advisors&advisor=${encodeURIComponent(uuid)}`;

export interface BlockedByStudents {
  message: string;
  link: string;
}

interface ErrLike {
  response?: {
    status?: number;
    data?: { reason?: string; message?: string; error_code?: string };
  };
}

// Non-null only for the 409 HAS_ACTIVE_STUDENTS refusal; `uuid` is the user being edited.
export const blocked_by_students = (e: unknown, uuid: string): BlockedByStudents | null => {
  const res = (e as ErrLike | null)?.response;
  if (res?.status !== 409 || res.data?.error_code !== HAS_ACTIVE_STUDENTS_CODE) return null;
  return {
    message: res.data.message || res.data.reason || 'This user still has active students.',
    link: advisors_tab_link(uuid)
  };
};

// Readers fall back to the first word of `name` when first_name is '' (E19).
export const name_parts = (u: {
  name?: string;
  first_name?: string;
  last_name?: string;
}): { first_name: string; last_name: string } => {
  if ((u.first_name || '').trim()) {
    return { first_name: u.first_name!.trim(), last_name: (u.last_name || '').trim() };
  }
  const [first = '', ...rest] = (u.name || '').trim().split(/\s+/);
  return { first_name: first, last_name: rest.join(' ') };
};

// Same shape the server stores: TRIM(CONCAT(first, ' ', last)).
export const full_name = (first_name: string, last_name: string): string =>
  `${first_name.trim()} ${last_name.trim()}`.trim();

// Mirrors goserver's 400 reason; the server refuses any write that leaves first_name empty.
export const FIRST_NAME_REQUIRED = 'First name is required';

// Save stays disabled while this holds (blank or whitespace-only).
export const first_name_missing = (first_name?: string | null): boolean =>
  !(first_name || '').trim();
